<template>
  <div class="grid grid-4">
    <!-- Card 1: Bandas -->
    <div class="grid-child box-shadow box-rounded">
      <div class="card-row">
        <div class="label">Band ({{ systemInfos.strategyParams.controller?.gridSize }}):</div>
        <div class="value">{{ marketData.priceBand.min }} / {{ marketData.priceBand.max }}</div>
      </div>
      <div class="card-row">
        <div class="label">RegularUnits</div>
        <div class="value">{{ volOnGrids.unitsBoughtOnGrid?.toFixed(4) }} | {{ systemInfos.strategyParams.maxRegularUnitsOnGrid}}</div>
      </div>
      <div class="card-row">
        <div class="label">RebuysSold</div>
        <div class="value">{{ volOnGrids.rebuySellsOnGrid }} | {{ systemInfos.strategyParams.maxRebuySellsOnGrid}}</div>
      </div>
      <!-- <div class="card-row">
        <div class="label">RegUnitsonRange</div>
        <div class="value">{{ kpis.regUnitsOnRange }}</div>
      </div> -->
      <div class="card-row">
        <div class="label">qtyEligibleForRebuys</div>
        <div class="value">{{ kpis.qtyEligibleForRebuys }}</div>
      </div>
      <div class="card-row">
        <div class="label">pmpEligibleForRebuys</div>
        <div class="value">{{ kpis.pmpEligibleForRebuys?.toFixed(2) }}</div>
      </div>
      <div class="card-row">
          <div class="label">spreadDeals</div>
          <div class="value">{{ kpis?.spreadDeals?.toFixed?.(3) ?? '--' }}</div>
      </div>

      <div class="card-row">
          <div class="label">rebuyDiscount</div>
          <div class="value">{{ kpis?.rebuyDiscount?.toFixed?.(3) ?? '--' }}</div>
      </div>
    </div>

    <!-- Card 2: Configs -->

    <div class="grid-child box-shadow box-rounded">

        <div class="card-row">
            <div class="label">Bias (B)</div>
            <div class="value">{{ systemInfos?.strategyParams?.controller?.biasConviction ?? '--' }}</div>
        </div>
        <div class="meter">
            <div class="meter-track segmented">
                <div class="meter-fill" :class="toneClass(biasConviction)" :style="{ width: pct(biasConviction) }"></div>
            </div>
            <div class="hint">
                <span>Bearish (0)</span>
                <span>Bullish (1)</span>
            </div>
        </div>

        <div class="divider"></div>

        <!-- Contexto de Preço -->
        <div class="card-row">
            <div class="label">Price On Range (R)</div>
            <div class="value">{{ kpis?.R?.toFixed?.(3) ?? '--' }}</div>
        </div>
        <div class="meter">
            <div class="meter-track segmented">
                <div class="meter-fill tone-gray" :style="{ width: pct(kpis.R) }"></div>
                <div class="meter-value-floating" :style="{ left: pct(kpis.R) }">${{ marketData.btcUsd?.toFixed(2) ?? '--' }}</div>
            </div>
            <div class="hint">
                <span>{{ systemInfos?.strategyParams?.controller?.supportPrice ?? '--' }} (S)</span>
                <span>{{ systemInfos?.strategyParams?.controller?.resistancePrice ?? '--' }} (R)</span>
            </div>
        </div>

        <!-- Convicção -->
        <!-- <div class="card-row">
            <div class="label">Conviction</div>
            <div class="value">{{ kpis?.C?.toFixed?.(3) ?? '--' }}</div>
        </div>
        <div class="meter">
            <div class="meter-track segmented">
                <div class="meter-fill tone-gray" :style="{ width: pct(kpis.C) }"></div>
            </div>
            <div class="hint">
                <span>Distribuição</span>
                <span>Acumulação</span>
            </div>
        </div> -->
    </div>


    <!-- Card 3: Pressure -->
    <div class="grid-child box-shadow box-rounded">

      <div class="card-row">
        <div class="label">RegPressure</div>
        <div class="value">{{ kpis?.regPressure?.toFixed?.(3) ?? '--' }}</div>
      </div>
      <div class="meter">
        <div class="meter-track segmented">
          <div class="meter-fill" :class="toneClass(kpis.regPressure, true)" :style="{ width: pct(kpis.regPressure) }"></div>
          <div class="meter-value-floating" :style="{ left: pct(kpis.regPressure) }">${{ kpis?.USDAllocRegOnRange?.toFixed(2) ?? '--' }}</div>
        </div>
        <div class="hint">
            <span>$0</span>
            <span>${{ systemInfos?.strategyParams?.controller?.maxRegularsMCA ?? '--' }}</span>
        </div>
      </div>

      <div class="divider"></div>

      <div class="card-row">
        <div class="label">LLP Pressure</div>
        <div class="value">{{ kpis?.llpPressure?.toFixed?.(3) ?? '--' }}</div>
      </div>
      <div class="meter">
        <div class="meter-track segmented">
          <div class="meter-fill" :class="toneClass(kpis.llpPressure, true)" :style="{ width: pct(kpis.llpPressure) }"></div>
          <div class="meter-value-floating" :style="{ left: pct(kpis.llpPressure) }">${{ Math.abs(kpis.llpRebuysOnRange) }}</div>
        </div>
        <div class="hint">
            <span>$0</span>
            <span>${{ systemInfos?.strategyParams?.controller?.maxRebuysLLP ?? '--' }}</span>
        </div>
      </div>
    </div>

    <!-- Card 4: Score do Sistema -->
    <div class="grid-child box-shadow box-rounded">

      <div class="card-row">
        <div class="label">Regulares</div>
        <div class="value">{{ kpis?.reg_score?.toFixed?.(3) ?? '--' }}</div>
      </div>
      <div class="meter">
        <div class="meter-track segmented">
          <div class="meter-fill tone-gray" :style="{ width: pct(kpis.reg_score) }"></div>
        </div>
        <div class="hint">
          <span>Buys Tight</span>
          <span>Buys Easing</span>
        </div>
        <div class="subtitle-infos"><span>MaxRegulars: {{ kpis.maxRegGrid}} BTC | {{ multiply(kpis.maxRegGrid, marketData.btcUsd).toFixed(2) }} USD</span></div>
      </div>

      <div class="divider"></div>

      <div class="card-row">
        <div class="label">Rebuys</div>
        <div class="value">{{ kpis?.reb_score?.toFixed?.(3) ?? '--' }}</div>
      </div>
      <div class="meter">
        <div class="meter-track segmented">
          <div class="meter-fill tone-gray" :style="{ width: pct(kpis.reb_score) }"></div>
        </div>
        <div class="hint">
          <span>Rebuys Tight</span>
          <span>Rebuys Easing</span>
        </div>
        <div class="subtitle-infos"><span>MaxRebuySells: {{ kpis.maxRebGrid}} BTC | {{ multiply(kpis.maxRebGrid, marketData.btcUsd).toFixed(2) }} USD</span></div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { pct, sum, multiply } from '../utils/funcs.js';

export default {
  name: "kpisIndicators",
  computed: {
    ...mapState({ systemInfos: state => state.systemInfos, ledger: state => state.ledger, kpis: state => state.kpis, marketData: state => state.marketData}),
    ...mapGetters(['rebuySellDensityByBin', 'kpisDataCalcs']),

    volOnGrids() {
      const { min: minBand, max: maxBand } = this.marketData.priceBand || {};
      if (!minBand || !maxBand) return { unitsBoughtOnGrid: 0, rebuySellsOnGrid: 0 };
      const ledger = Object.values(this.ledger).filter(u => u.status === 'pending' && u.bucket === 'regular')

      const totalQty = ledger.filter(u => {
          const price = u.current?.avgPrice || 0;
          const qty = u.current?.qty || 0;
          return qty > 0 && price >= minBand && price < maxBand;
        }).reduce((sum, u) => sum + (u.current?.qty || 0), 0);

      const sumQtyInBand = (densityByBin) =>
        Object.keys(densityByBin)
          .filter(bin => bin >= minBand && bin < maxBand)
          .reduce((sum, bin) => sum + densityByBin[bin].qty, 0);

      return {
        unitsBoughtOnGrid: totalQty,
        rebuySellsOnGrid: sumQtyInBand(this.rebuySellDensityByBin)
      };
    },

    biasConviction() { return this.systemInfos?.strategyParams?.controller?.biasConviction; },
  },
  methods: {

    sum, pct, multiply,
    toneClass(v, inverted = false) {
      let n = v;

      // Se invertido, 0 vira 1, 0.2 vira 0.8, etc.
      if (inverted) {
        n = 1 - n;
      }

      if (n < 0.3) return 'tone-red';
      if (n < 0.6) return 'tone-yellow';
      return 'tone-green';
    }
  }
};
</script>

<style>

/* meters */
.meter {
  margin: 6px 0 10px;
}

.meter-track {
  position: relative;
  height: 16px;
  border-radius: 8px;
  background: rgba(255,255,255,0.06);
}

/* segmented/pontilhado */
.meter-track.segmented,
.slider-track.segmented {
  background-image: repeating-linear-gradient(
    90deg,
    rgba(255,255,255,0.14) 0 8px,
    rgba(255,255,255,0.02) 8px 14px
  );
}

.meter-value-floating {
  position: absolute;
  bottom: 0;
  color: #333 !important;
  transform: translateX(-130%);
  font-size: 10px;
  white-space: nowrap;
}

.meter-fill {
  height: 100%;
  border-radius: 8px;
  transition: width 200ms ease;
}

.tone-red { background: linear-gradient(90deg, #ef4444, #f87171); }
.tone-yellow { background: linear-gradient(90deg, #f59e0b, #fbbf24); }
.tone-green { background: linear-gradient(90deg, #10b981, #34d399); }
.tone-gray { background: linear-gradient(90deg, #595959, #8b8e92); }

/* slider (contexto) */
.slider {
  margin: 6px 0 12px;
}
.slider-track {
  position: relative;
  height: 12px;
  border-radius: 8px;
  background: rgba(255,255,255,0.06);
}
.slider-marker {
  position: absolute;
  top: -4px;
  width: 10px;
  height: 20px;
  border-radius: 999px;
  background: #f8fafc;
  box-shadow: 0 0 0 2px rgba(0,0,0,0.35);
  transform: translateX(-5px);
}

.hint {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  opacity: 0.75;
  margin-top: 6px;
}

.subtitle-infos {
  display: flex;
  margin-top:15px;
}

@media (max-width: 980px) {
  .kpis-cards {
    grid-template-columns: 1fr;
  }
}
</style>
